import { render, staticRenderFns } from "./CustomerPortalLanding.vue?vue&type=template&id=0d55dc81"
import script from "./CustomerPortalLanding.vue?vue&type=script&lang=js"
export * from "./CustomerPortalLanding.vue?vue&type=script&lang=js"
import style0 from "./CustomerPortalLanding.vue?vue&type=style&index=0&id=0d55dc81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports